import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AuthenticationQueryModel } from 'data-ng-authentication';

export class LogoutLinkController {
  private disableLogoutButton: boolean = false;
  constructor(private ngAuthenticationQueryModel: AuthenticationQueryModel, private logoutCommand: ICommand) {}
  initialize() {
    this.disableLogoutButton = false;
  }

  logoutOutUser() {
    this.logoutCommand();
    this.disableLogoutButton = true;
  }

  $onInit() {
    this.initialize();
  }
  $onChange() {
    this.initialize();
  }
}

export class LogoutLinkComponent implements ng.IComponentOptions {
  public templateUrl: string = 'capability-ng-authentication/src/components/logout_link/logout_link.html';
  public controller = LogoutLinkController;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/components/logout_link/logout_link.ts